import "./App.css";
import MainRoutes from "./router";
import Amplify from "aws-amplify";
import React from "react";
import { ContextLanguage } from "./context/Context.Language";
import { useLocation } from "react-router-dom";
// import FunctionRepleteFont from "./utils/FunctionRepleteFont";
import { StoreLoadingOrder, SystemStoreOrders } from "./utils/useStorage";
import api from "./utils/useApi";
import { useSelector } from "react-redux";

// import { useSelector } from "react-redux";

Amplify.configure({
  Auth: {
    identityPoolId: "ap-southeast-1:46f2de95-ff38-4878-af78-810695713aa1",
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_NMK1CThZV",
    userPoolWebClientId: "2h8sb8sk963tc5fi62h8gcteqt",
  },
  Storage: {
    bucket: "bucketlaundry92708-dev",
    region: "ap-southeast-1",
  },
});

const App = () => {
  console.warn = function filterWarnings() {};
  console.error = function filterErrors() {};
  // const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const [loaded, setLoaded] = React.useState(false);
  const { user } = useSelector((state) => state.auth);
  const setOrders = SystemStoreOrders((state) => state.setOrders);
  const { FunctionChangeLanguageTo } = React.useContext(ContextLanguage);

  const setLoadingOrder = StoreLoadingOrder((state) => state.setLoadingOrder);

  // React.useEffect(() => {
  //   window.requestAnimationFrame(() => {
  //     FunctionRepleteFont({ language });
  //   });
  // }, [language, location]);

  React.useEffect(() => {
    const hasSearch = location.search.includes("?");
    const searchValue = location.search.split("?")[1];
    if (hasSearch) {
      if (searchValue === "th") {
        FunctionChangeLanguageTo("TH");
      }
      if (searchValue === "en") {
        FunctionChangeLanguageTo("EN");
      }
    }
    setTimeout(() => {
      setLoaded(!loaded);
    }, 200);
  }, [setLoaded, location]);

  React.useEffect(() => {
    let mounted = true;

    if (user && setOrders) {
      FunctionLoadMyOrder(setOrders);
    } else {
      setOrders([]);
    }

    return () => {
      mounted = false;
    };
  }, [user, setOrders]);

  const FunctionLoadMyOrder = async (setOrders) => {
    try {
      setLoadingOrder(true);
      const { data } = await api.post("/orders/get", {
        phone_number: user?.phone_number,
      });
      setOrders(data?.orders);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingOrder(false);
    }
  };

  // React.useEffect(() => {
  //   FunctionRepleteFont({ language });
  // }, [language, location, loaded]);

  try {
    return <MainRoutes />;
  } catch (error) {
    console.error("error", error);
  }
};

export default App;
